import { combineReducers } from 'redux';
import orderStep from './orderStep';
import orderDetail from './orderDetail';
import order from './order';
import preOrder from './preOrder';
import payment from './payment';
import searchKeyword from './searchKeyword';
import cart from './cart';
import productModal from './productModal';
import discountModal from './discountModal';
import drawer from './drawer';
import products from './products';
import scanner from './scanner';
import receipt from './receipt';
import invoice from './invoice';
import user from './user';
import channel from './channel';
import member from './member';

export default combineReducers({
  order,
  preOrder,
  payment,
  orderStep,
  orderDetail,
  searchKeyword,
  cart,
  productModal,
  products,
  discountModal,
  drawer,
  scanner,
  receipt,
  invoice,
  user,
  channel,
  member,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js